<template>
  <div class="py-1">
    <MenuOption
      v-if="hasFailedInvoices && canUser('orders.billing')"
      id="retry-all-failed"
      :title="$t('W: Forsøg alle fejlede igen')"
      :isDisabled="isRetryingAllFailed"
      @select="onRetryClick">
      <template #icon>
        <IconLucideRotateCw class="h-4 w-4" />
      </template>
    </MenuOption>
    <!-- DEV: run the BC invoice batch for this lab immediately, instead of waiting for the
         daily scheduled trigger. A real push to BC — not a simulation. -->
    <div
      v-if="isBcEnabled && isDeveloper && showDevActions"
      :class="hasFailedInvoices && canUser('orders.billing') ? 'mt-1 border-t border-border-subtle pt-1' : ''">
      <MenuOption
        id="run-bc-invoice-batch"
        :title="$t('area.business-central.invoice.action.run-batch-dev')"
        :isDisabled="isRunningBcInvoiceBatch"
        @select="onRunClick">
        <template #icon>
          <div class="flex items-center gap-1.5">
            <DevBadge />
            <IconLucidePlay class="h-4 w-4" />
          </div>
        </template>
      </MenuOption>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/userStore'

export default {
  name: 'InvoicesPageMenu',

  emits: ['close'],

  props: {
    isBcEnabled: { type: Boolean, default: false },
    hasFailedInvoices: { type: Boolean, default: false },
    isRetryingAllFailed: { type: Boolean, default: false },
    onRetryAllFailed: { type: Function as PropType<() => Promise<void>>, required: true },
    isRunningBcInvoiceBatch: { type: Boolean, default: false },
    onRunBcInvoiceBatch: { type: Function as PropType<() => Promise<void>>, required: true },
  },

  computed: {
    ...mapState(useUserStore, ['isDeveloper', 'showDevActions']),
  },

  methods: {
    ...mapActions(useUserStore, ['canUser']),

    async onRetryClick(): Promise<void> {
      await this.onRetryAllFailed()
      this.$emit('close')
    },

    async onRunClick(): Promise<void> {
      await this.onRunBcInvoiceBatch()
      this.$emit('close')
    },
  },
}
</script>
